export default __webpack_public_path__ + "static/media/plain-sticker-oe.6896f361.png";